module.exports = __webpack_public_path__ + "static/img/header@2x.a9c9453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_template/header@2x.png
// module id = v8u6
// module chunks = 0